<template>
  <form novalidate>
    <div class="rounded-lg bg-gray-200 p-12">
      <div class="mb-8 font-bold text-dark">
        {{ $t('loyalty.buyPoints.paymentMethod.label') }}
      </div>

      <div class="flex flex-wrap items-center gap-20">
        <button
          v-for="item in PAYMENT_METHODS"
          :key="item.key"
          class="flex h-40 w-60 items-center justify-center rounded-md border border-line bg-white"
          type="button"
          :class="{
            'border-primary': selectedPaymentMethod === item.key,
          }"
          :title="item.key"
          @click="selectedPaymentMethod = item.key"
        >
          <component :is="item.icon" />
        </button>
      </div>
    </div>

    <div class="my-24">
      <JTextInput
        required
        :label="$t('loyalty.buyPoints.ticketId.label')"
        :placeholder="$t('loyalty.buyPoints.ticketId.placeholder')"
        :hint="$t('loyalty.buyPoints.ticketId.hint')"
      />
    </div>

    <ul
      class="space-y-12 [&>li]:flex [&>li]:items-center [&>li]:justify-between [&_span:nth-child(1)]:text-subject [&_span:nth-child(1)]:text-gray-600 [&_span:nth-child(2)]:font-bold [&_span:nth-child(2)]:text-dark"
    >
      <li>
        <span>{{ $t('points') }}</span>
        <span>100 {{ $t('points') }}</span>
      </li>

      <li>
        <span>{{ $t('fee') }}</span>
        <span>3 {{ $t('points') }}</span>
      </li>
    </ul>

    <hr class="my-16 border-line" />

    <ul class="mb-24 pb-12">
      <li
        class="flex items-center justify-between text-pane-header font-bold text-dark"
      >
        <span>{{ $t('total') }}</span>
        <span>$318.85</span>
      </li>
    </ul>

    <JRow
      spaceMd="8"
      spaceLg="8"
      spaceXl="8"
      class="!-mx-16 -mb-12 border-t border-line pt-12"
    >
      <JCol md="6" lg="6" xl="6">
        <JButton
          block
          variant="tonal"
          color="secondary"
          type="button"
          @click="setActiveIndex(-1)"
        >
          {{ $t('words.cancel') }}
        </JButton>
      </JCol>

      <JCol md="6" lg="6" xl="6">
        <JButton block>{{ $t('words.confirm') }}</JButton>
      </JCol>
    </JRow>
  </form>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { JButton, JCol, JRow, JTextInput } from '@journey/ui-kit'
import { PAYMENT_METHODS } from './LoyaltyManagePointsBuyPoints.constants'
import useManagePoints from '@/modules/Loyalty/composables/useManagePoints'

const { setActiveIndex } = useManagePoints()

const selectedPaymentMethod = ref('')
</script>
